const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
const PHONE_CHARS = /^[\d\s()+.-]+$/

export function isValidEmail(value) {
  return EMAIL_PATTERN.test(value.trim())
}

export function isValidPhone(value) {
  const trimmed = value.trim()
  const digits = trimmed.replace(/\D/g, '').length
  return PHONE_CHARS.test(trimmed) && digits >= 10 && digits <= 15
}
